import Axios from 'axios';
import { protectedResources } from '../authConfig';

//const getAccessToken  = sessionStorage.getItem('AccessToken');
const URL =
  protectedResources.apiHRMobile.baseApi + '/api/v1/AdvanceSalary/GetAnnouncement';
let tokenKey;

export async function getAnnouncementHighlight() {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {
    year: 2022,
    month: 8,
  };

  try {
    // const getData = JSON.parse(localStorage.getItem('obj_announcement_highlight'));
    // if(getData === null){
    const response = await Axios.post(URL, bodyParameters, config);
    //localStorage.setItem("obj_announcement_highlight", JSON.stringify(response.data));
    return await response.data;
    // }else{
    // return await getData;
    //}
  } catch (error) {
    console.error(error);
  }
}
